import React, { FunctionComponent } from 'react';
import Helmet from 'react-helmet';
import { Props } from './type';
import { Query } from './query';

export const SEO: FunctionComponent<Props> = ({
    description = '',
    lang = 'en',
    meta = [],
    siteTitle,
    keywords = [],
    title,
}) => {
    return (
        <Query>
            {(data) => {
                console.warn('render!');

                const metaDescription =
                    description || data.site.siteMetadata.description;
                const metaSiteTitle = siteTitle || data.site.siteMetadata.title;
                return (
                    <Helmet
                        htmlAttributes={{
                            lang,
                        }}
                        title={title}
                        titleTemplate={`%s | ${metaSiteTitle}`}
                        meta={[
                            { charSet: 'utf-8' },
                            {
                                name: 'viewport',
                                content:
                                    'width=device-width, initial-scale=1, shrink-to-fit=no',
                            },
                            {
                                name: `description`,
                                content: metaDescription,
                            },
                            {
                                property: `og:title`,
                                content: title,
                            },
                            {
                                property: `og:description`,
                                content: metaDescription,
                            },
                            {
                                property: `og:type`,
                                content: `website`,
                            },
                            {
                                name: `twitter:card`,
                                content: `summary`,
                            },
                            {
                                name: `twitter:creator`,
                                content: data.site.siteMetadata.author,
                            },
                            {
                                name: `twitter:title`,
                                content: title,
                            },
                            {
                                name: `twitter:description`,
                                content: metaDescription,
                            },
                        ]
                            .concat(
                                keywords.length > 0
                                    ? [
                                          {
                                              name: `keywords`,
                                              content: keywords.join(`, `),
                                          },
                                      ]
                                    : [],
                            )
                            .concat(meta)}
                    />
                );
            }}
        </Query>
    );
};
